import { useEffect, useState } from "react";
import axios from "axios";
import { Sparkles } from "lucide-react";
import { API } from "@/lib/api";
import { ProductChip } from "@/components/ai/ProductChip";

export default function CartRecommendations({ cartIds }) {
  const [recs, setRecs] = useState([]);
  const key = [...cartIds].sort().join(",");

  useEffect(() => {
    let cancelled = false;
    const t = setTimeout(() => {
      axios.post(`${API}/ai/recommend`, { cart_ids: key ? key.split(",") : [] })
        .then((r) => { if (!cancelled) setRecs(r.data.recommendations.filter((p) => !cartIds.includes(p.id))); })
        .catch(() => { if (!cancelled) setRecs([]); });
    }, 500);
    return () => { cancelled = true; clearTimeout(t); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  const visible = recs.filter((p) => !cartIds.includes(p.id));
  if (visible.length === 0) return null;
  return (
    <div className="rounded-2xl border border-dashed border-saffron/50 bg-saffron-subtle/40 p-3" data-testid="cart-recommendations">
      <p className="mb-2 flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.18em] text-saffron-dark"><Sparkles className="h-3 w-3" /> Goes well with your basket</p>
      <div className="space-y-2">
        {visible.map((p) => <ProductChip key={p.id} product={p} reason={p.reason} testIdPrefix="cart-rec" />)}
      </div>
    </div>
  );
}
